import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';
import { MaxBrainAudience } from './audience.model';

export class AudiencesStateModel extends SubentityStateModel {
    defaultAudiencesList: MaxBrainAudience[];
    defaultAudienceTotalCount: number;
}
